/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/londonlive/"

const londonlive: CommunityData = {
  code: "londonlive",
  inviteCode: "londonlive",
  name: "London Live",
  thumbnail: "",
  favicon: "",
  waitlist: true,
  defaultCurrency: "GBP",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ldl-020`,
  socials: {},
  styles: {
    global: {
      mobileOnly: true,
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.jpg`,
        styles: "w-[134px] h-[34px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[134px] h-[34px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f6f3ef",
      asideBg: "#f6f3ef",
      asideStyles: "border-r border-[#000000cc]",
      contentBg: "#f6f3ef",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['RoughSerifRegular']",
      primaryButton:
        "bg-[#000000] border border-[#000000] px-[18px] py-[18px] gap-y-[6px] !text-[#f6f3ef] font-['RoughSerifRegular'] !text-[20px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#222222",
      sideBarSeparator: "border-r-[1px] border-[#000000cc]",
      separator: "border-[#000000]",
      item: "text-[#222222] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%] gap-x-[10px] text-opacity-50 border-b border-[#000000cc] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#f6f3ef] border border-[#000000cc] !pb-8",
      titles: "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000cc]",
        sectionTitle:
          "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#f7f2ee00] border border-[#000000cc]",
          mediaContainer: "w-full sm:w-[256px] h-[256px] relative",
          media: "w-full h-[256px] object-cover",
          placeholderMedia: "w-full h-[256px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#000000] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000cc]",
        sectionTitle:
          "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#f7f2ee00] border border-[#000000cc]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 h-[180px] relative",
          media: "w-full h-[180px] object-cover",
          placeholderMedia: "w-full h-[180px] bg-gray-400",
          content: "flex flex-col p-4 bg-transparent",
          title: "text-[#000000] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%]",
          subtitle:
            "text-[#000000] font-['CourierPrimeRegular'] text-[11px] text-left leading-[115%] mt-2",
          location:
            "text-[#000000] font-['CourierPrimeRegular'] text-[11px] text-left leading-[115%] mt-1",
          date: "text-[#000000] font-['CourierPrimeRegular'] text-[11px] text-left leading-[115%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['RoughSerifRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['CourierPrimeRegular'] text-[16px] text-left leading-[115%]",
        customShopImageStyle: "border border-[#000000]",
        sectionTitle:
          "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#f6f3ef] border border-[#000000cc] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#000000]",
        title: "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%]",
        subtitle:
          "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%] mb-4 mt-2",
        button:
          "bg-[#000000] border border-[#000000] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#f6f3ef] font-['RoughSerifRegular'] !text-[20px] text-left leading-[100%]",
        questions: "text-[12px] text-left leading-[115%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['RoughSerifRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['RoughSerifRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['RoughSerifRegular'] text-[24px] text-left leading-[100%]",
        text: "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['RoughSerifRegular'] text-[28px] text-left leading-[100%] px-4 sm:px-8 pt-4 sm:pt-8 pb-4 sm:pb-6 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#f6f3ef] border border-[#000000cc] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#f6f3ef] border border-[#000000cc] rounded-none px-3 py-3 text-[#000000] font-['RoughSerifRegular'] text-[16px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto bg-[#f7f2ee00] border border-[#000000cc] mb-4 p-4 overflow-hidden",
          media: "!hidden",
          name: "text-[#000000] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%]",
          description:
            "text-[#000000] font-['CourierPrimeRegular'] text-[12px] text-left leading-[115%] !mt-1 flex flex-row",
          price:
            "text-[#000000] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%] !mt-1",
          quantity:
            "text-[#000000] font-['RoughSerifRegular'] text-[16px] text-left leading-[100%]",
          status: "text-[#000000] font-['RoughSerifRegular'] text-[18px] text-left leading-[100%]",
          counterContainer:
            "bg-[#f6f3ef] border border-[#000000cc] !px-3 !py-3 gap-x-4 !w-fit !h-[43px]",
          button:
            "!bg-[#f6f3ef] border border-[#000000cc] rounded-none px-3 py-3 text-[#000000] font-['RoughSerifRegular'] text-[16px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default londonlive
